(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["HEMP-VERTICAL-2"] && !Shopify.designMode) return;
  try {
    
  
  var tab; // заголовок вкладки
var tabContent; // блок содержащий контент вкладки


window.onload=function() {
    tabContent=document.getElementsByClassName('tabContent');
    tab=document.getElementsByClassName('tab');
    hideTabsContent(1);
}

document.getElementById('tabs').onclick= function (event) {
    var target=event.target;
    if (target.className=='tab') {
       for (var i=0; i<tab.length; i++) {
           if (target == tab[i]) {
               showTabsContent(i);
               break;
           }
       }
    }
}

function hideTabsContent(a) {
    for (var i=a; i<tabContent.length; i++) {
        tabContent[i].classList.remove('show');
        tabContent[i].classList.add("hide");
        tab[i].classList.remove('whiteborder');
    }
}

function showTabsContent(b){
    if (tabContent[b].classList.contains('hide')) {
        hideTabsContent(0);
        tab[b].classList.add('whiteborder');
        tabContent[b].classList.remove('hide');
        tabContent[b].classList.add('show');
    }
}















  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Hemp-Vertical"] && !Shopify.designMode) return;
  try {
    
  
  var tab; // заголовок вкладки
var tabContent; // блок содержащий контент вкладки


window.onload=function() {
    tabContent=document.getElementsByClassName('tabContent');
    tab=document.getElementsByClassName('tab');
    hideTabsContent(1);
}

document.getElementById('tabs').onclick= function (event) {
    var target=event.target;
    if (target.className=='tab') {
       for (var i=0; i<tab.length; i++) {
           if (target == tab[i]) {
               showTabsContent(i);
               break;
           }
       }
    }
}

function hideTabsContent(a) {
    for (var i=a; i<tabContent.length; i++) {
        tabContent[i].classList.remove('show');
        tabContent[i].classList.add("hide");
        tab[i].classList.remove('whiteborder');
    }
}

function showTabsContent(b){
    if (tabContent[b].classList.contains('hide')) {
        hideTabsContent(0);
        tab[b].classList.add('whiteborder');
        tabContent[b].classList.remove('hide');
        tabContent[b].classList.add('show');
    }
}















  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["LT-Age-Verification"]) return;
  try {
    
    var modal = document.getElementById('age-verification-modal');
    var yesButton = document.getElementById('lt-yes-button');
    var noButton = document.getElementById('lt-no-button');

    // Function to set a session cookie with expiration
    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    // Attach getCookie to the global window object
    window.getCookie = function(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    };

    function checkCookie() {
        var user = getCookie("ageVerified");
        if (user) {
            modal.style.display = "none";
        } else {
            modal.style.display = "flex";
            console.log('Displaying modal.');
        }
    }

    yesButton.addEventListener('click', function() {
        setCookie('ageVerified', 'true', 7); // Set cookie for 7 days
        modal.style.display = 'none'; // Hide the modal
    });

    noButton.addEventListener('click', function() {
        window.location.href = 'https://www.google.com'; // Redirect to Google
    });

    console.log('age verifcation')

    checkCookie(); // Check the cookie status on page load



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cannabis-vertical"] && !Shopify.designMode) return;
  try {
    
  
  var tab; // заголовок вкладки
var tabContent; // блок содержащий контент вкладки


window.onload=function() {
    tabContent=document.getElementsByClassName('tabContent');
    tab=document.getElementsByClassName('tab');
    hideTabsContent(1);
}

document.getElementById('tabs').onclick= function (event) {
    var target=event.target;
    if (target.className=='tab') {
       for (var i=0; i<tab.length; i++) {
           if (target == tab[i]) {
               showTabsContent(i);
               break;
           }
       }
    }
}

function hideTabsContent(a) {
    for (var i=a; i<tabContent.length; i++) {
        tabContent[i].classList.remove('show');
        tabContent[i].classList.add("hide");
        tab[i].classList.remove('whiteborder');
    }
}

function showTabsContent(b){
    if (tabContent[b].classList.contains('hide')) {
        hideTabsContent(0);
        tab[b].classList.add('whiteborder');
        tabContent[b].classList.remove('hide');
        tabContent[b].classList.add('show');
    }
}















  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom_tabs"] && !Shopify.designMode) return;
  try {
    
  
  var tab; // заголовок вкладки
var tabContent; // блок содержащий контент вкладки


window.onload=function() {
    tabContent=document.getElementsByClassName('tabContent');
    tab=document.getElementsByClassName('tab');
    hideTabsContent(1);
}

document.getElementById('tabs').onclick= function (event) {
    var target=event.target;
    if (target.className=='tab') {
       for (var i=0; i<tab.length; i++) {
           if (target == tab[i]) {
               showTabsContent(i);
               break;
           }
       }
    }
}

function hideTabsContent(a) {
    for (var i=a; i<tabContent.length; i++) {
        tabContent[i].classList.remove('show');
        tabContent[i].classList.add("hide");
        tab[i].classList.remove('whiteborder');
    }
}

function showTabsContent(b){
    if (tabContent[b].classList.contains('hide')) {
        hideTabsContent(0);
        tab[b].classList.add('whiteborder');
        tabContent[b].classList.remove('hide');
        tabContent[b].classList.add('show');
    }
}















  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lt-cannabis"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const tabs = document.querySelectorAll('.navtab');
  const underline = document.querySelector('.underline');
  const swiperCannabisContents = document.querySelectorAll('.swiper-cannabis');
  const initSwiper = document.querySelector('[data-target="edible"]'); // Set initial active to 'edible'

  // Function to update the underline position and width
  function updateUnderline() {
    const activeTab = document.querySelector('.navtab.ap-active');
    underline.style.width = `${activeTab.offsetWidth}px`;
    underline.style.left = `${activeTab.offsetLeft}px`;
  }

  // Set the first active tab and content to 'edible' on load
  function setInitialActive() {
    if (initSwiper) {
      setContentActive(initSwiper); // Set initial content to 'edible'
      initSwiper.classList.add('ap-active'); // Make sure the 'edible' tab is active
      setTimeout(updateUnderline, 100); // Small delay to ensure proper rendering
    }
  }

  // Click event for each tab to switch active content
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('ap-active')); // Remove active state from all tabs
      tab.classList.add('ap-active'); // Set the clicked tab as active

      const target = tab.getAttribute('data-target'); // Get the target content by the data attribute
      setContentActive(tab); // Update the content displayed

      updateUnderline(); // Update underline position and width after tab click
    });
  });

  // Function to set active content based on the clicked tab
  function setContentActive(tab) {
    const target = tab.getAttribute('data-target');
    swiperCannabisContents.forEach(content => {
      if (content.id === target) {
        content.classList.add('swiper-cannabis-active'); // Show content matching the clicked tab
      } else {
        content.classList.remove('swiper-cannabis-active'); // Hide other content
      }
    });
    tab.classList.add('ap-active'); // Ensure the clicked tab is set as active
    updateUnderline(); // Update underline
  }

  // Initialize Swiper for each content section
  const edibleSwiper = new Swiper('#edible', {
    slidesPerView: 2,
    spaceBetween: 5,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
    },
    breakpoints: {
      900: {
        slidesPerView: 4,
        spaceBetween: 10,
      }
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    scrollbar: {
      el: '.swiper-scrollbar',
    },
  });

  const originalSwiper = new Swiper('#original', {
    slidesPerView: 2,
    spaceBetween: 5,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
    },
    breakpoints: {
      900: {
        slidesPerView: 4,
        spaceBetween: 10,
      }
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    scrollbar: {
      el: '.swiper-scrollbar',
    },
  });

  const exoticSwiper = new Swiper('#exotic', {
    slidesPerView: 2,
    spaceBetween: 5,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
    },
    breakpoints: {
      900: {
        slidesPerView: 4,
        spaceBetween: 10,
      }
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    scrollbar: {
      el: '.swiper-scrollbar',
    },
  });

  const liveResinSwiper = new Swiper('#live-resin', {
    slidesPerView: 2,
    spaceBetween: 5,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
    },
    breakpoints: {
      900: {
        slidesPerView: 4,
        spaceBetween: 10,
      }
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    scrollbar: {
      el: '.swiper-scrollbar',
    },
  });

  // Initial calls when the DOM is fully loaded
  updateUnderline();
  window.addEventListener('resize', updateUnderline); // Update underline on window resize
  setInitialActive(); // Set the initial active tab and content to 'edible'
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lt-footer"] && !Shopify.designMode) return;
  try {
    
      document.addEventListener("DOMContentLoaded", function () {
        var accordionHeaders = document.querySelectorAll(".accordion-header");

        accordionHeaders.forEach(function (header) {
          header.addEventListener("click", function () {
            var content = this.nextElementSibling;
            var chevron = this.querySelector(".chevron");

            // Toggle the open class to rotate the chevron
            this.classList.toggle("open");

            // Toggle the display of the content
            if (content.style.display === "block") {
              content.style.display = "none";
            } else {
              content.style.display = "block";
            }
          });
        });
      });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lt-hemp"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const tabs = document.querySelectorAll('.hemp-slider-tab');
  const underlineSliderH = document.querySelector('.hemp-slider-underline');
  const swiperHempContents = document.querySelectorAll('.swiper-hemp');
  const initSwiper = document.querySelector('[data-hemp="smacked"]'); // Set initial active to 'smacked'

  // Function to update the underline position and width
  function updateUnderlineSliderH() {
    const activeTab = document.querySelector('.hemp-slider-tab.ap-active');
    underlineSliderH.style.width = `${activeTab.offsetWidth}px`;
    underlineSliderH.style.left = `${activeTab.offsetLeft}px`;
  }
  

  // Set the first active tab and content to 'smacked' on load
  function setInitialActive() {
    if (initSwiper) {
      setContentActive(initSwiper); // Set initial content to 'smacked'
      initSwiper.classList.add('ap-active'); // Make sure the 'smacked' tab is active
      updateUnderlineSliderH(); // Update underline for the initial tab
    }
  }

  // Click event for each tab to switch active content
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('ap-active')); // Remove active state from all tabs
      tab.classList.add('ap-active'); // Set the clicked tab as active

      const target = tab.getAttribute('data-hemp'); // Get the target content by the data attribute
      setContentActive(tab); // Update the content displayed

      updateUnderlineSliderH(); // Update underline position and width after tab click
    });
  });

  // Function to set active content based on the clicked tab
  function setContentActive(tab) {
    const target = tab.getAttribute('data-hemp');
    swiperHempContents.forEach(content => {
      if (content.id === target) {
        content.classList.add('swiper-hemp-active'); // Show content matching the clicked tab
      } else {
        content.classList.remove('swiper-hemp-active'); // Hide other content
      }
    });
    tab.classList.add('ap-active'); // Ensure the clicked tab is set as active
    updateUnderlineSliderH(); // Update underline
  }

  // Initialize Swiper for each content section
  const blendSwipers = document.querySelectorAll('.swiper-hemp');
  blendSwipers.forEach(function(blendSwiper) {
    const blendId = blendSwiper.getAttribute('id');

    new Swiper(`#${blendId}`, {
      slidesPerView: 2,
      spaceBetween: 5,
      loop: true,
      pagination: {
        el: `#${blendId} .swiper-pagination_hemp`,
      },
      breakpoints: {
        900: {
          slidesPerView: 4,
          spaceBetween: 10,
        }
      },
      navigation: {
        nextEl: `#${blendId} .swiper-button-next`,
        prevEl: `#${blendId} .swiper-button-prev`,
      },
      scrollbar: {
        el: `#${blendId} .swiper-scrollbar`,
      },
    });
  });

  // Initial calls when the DOM is fully loaded
  updateUnderlineSliderH();
  window.addEventListener('resize', updateUnderlineSliderH); // Update underline on window resize
  setInitialActive(); // Set the initial active tab and content to 'smacked'
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-hemp"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const hemptabs = document.querySelectorAll('.hemptab');
    const hempUnderline = document.querySelector('.hemp-underline');
    const hempItems = document.querySelectorAll('.hemp-item')
  
    function updateHempUnderline() {
      const activeTab = document.querySelector('.hemptab-active');
      if(activeTab) {
        hempUnderline.style.width = `${activeTab.offsetWidth}px`;
        hempUnderline.style.left = `${activeTab.offsetLeft}px`;
      }
    }
  
    function setHempQueryParam(param, value) {
      let url = new URL(window.location.href);
      let params = new URLSearchParams(url.search);
      params.set(param, value);
      url.search = params.toString();
      window.history.pushState({}, '', url);
    }
  
    function setActiveHempTabFromURL() {
      const params = new URLSearchParams(window.location.search);
      const activeTab = params.get('strain');
      
      if (activeTab) {
        hemptabs.forEach(tab => {
          if (tab.getAttribute('data-target') === activeTab) {
            setHempItemActive(tab);
          } else {
            tab.classList.remove('hemptab-active');
          }
        });
      } 
    }
  
    function setHempItemActive(tab) {
      const target = tab.getAttribute('data-target');
      
      hempItems.forEach(item => {
        if (item.id === target) {
          item.classList.add('hemp-item-active');
        } else {
          item.classList.remove('hemp-item-active');
        }
      });
      tab.classList.add('hemptab-active');
      updateHempUnderline();
    }
  
    // Add event listener for tab clicks
    function initTabListeners() {
      hemptabs.forEach(tab => {
        tab.addEventListener('click', () => {
          tab.classList.remove('hemptab-active');
          tab.classList.add('hemptab-active');
          const target = tab.getAttribute('data-target');
  
          setHempQueryParam('strain', target);
          setActiveHempTabFromURL();
          updateHempUnderline();
        });
      });
    }
  
    // Ensure everything only runs once the page has fully loaded
    window.addEventListener('load', () => {
      initTabListeners();
      setActiveHempTabFromURL();
      updateHempUnderline();  // Update underline after the content is fully loaded
    });
  
    window.addEventListener('resize', updateHempUnderline);
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab_of_collections"] && !Shopify.designMode) return;
  try {
    

 document.addEventListener("DOMContentLoaded", function() {
    var tabs = document.querySelectorAll('.collection-tabs .tabs li a');
    var firstTab = tabs[0];
    var firstTabCollectionHandle = firstTab.getAttribute('data-collection-handle');
    var firstTabContent = document.getElementById(firstTabCollectionHandle);

    if (firstTab && firstTabContent) {
      firstTab.classList.add('active');
      firstTabContent.classList.add('active');
      firstTabContent.style.display = 'block';
    }

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function(e) {
        e.preventDefault();

        var collectionHandle = this.getAttribute('data-collection-handle');
        var collectionContent = document.getElementById(collectionHandle);

        if (collectionContent) {
          var activeTab = document.querySelector('.collection-tabs .tabs li a.active');
          var activeContent = document.querySelector('.collection-tabs .collection-content.active');

          if (activeTab) {
            activeTab.classList.remove('active');
          }
          if (activeContent) {
            activeContent.classList.remove('active');
            activeContent.style.display = 'none';
          }

          this.classList.add('active');
          collectionContent.classList.add('active');
          collectionContent.style.display = 'block';

          // Scroll to the collection content
          var yOffset = -100; // Adjust the scroll offset if needed
          var y = collectionContent.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      });
    });
  });

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-for-1g-cannabis"] && !Shopify.designMode) return;
  try {
    
  
  var tab; // заголовок вкладки
var tabContent; // блок содержащий контент вкладки


window.onload=function() {
    tabContent=document.getElementsByClassName('tabContent');
    tab=document.getElementsByClassName('tab');
    hideTabsContent(1);
}

document.getElementById('tabs').onclick= function (event) {
    var target=event.target;
    if (target.className=='tab') {
       for (var i=0; i<tab.length; i++) {
           if (target == tab[i]) {
               showTabsContent(i);
               break;
           }
       }
    }
}

function hideTabsContent(a) {
    for (var i=a; i<tabContent.length; i++) {
        tabContent[i].classList.remove('show');
        tabContent[i].classList.add("hide");
        tab[i].classList.remove('whiteborder');
    }
}

function showTabsContent(b){
    if (tabContent[b].classList.contains('hide')) {
        hideTabsContent(0);
        tab[b].classList.add('whiteborder');
        tabContent[b].classList.remove('hide');
        tabContent[b].classList.add('show');
    }
}















  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-for-2g-cannabis"] && !Shopify.designMode) return;
  try {
    
  
  var tab; // заголовок вкладки
var tabContent; // блок содержащий контент вкладки


window.onload=function() {
    tabContent=document.getElementsByClassName('tabContent');
    tab=document.getElementsByClassName('tab');
    hideTabsContent(1);
}

document.getElementById('tabs').onclick= function (event) {
    var target=event.target;
    if (target.className=='tab') {
       for (var i=0; i<tab.length; i++) {
           if (target == tab[i]) {
               showTabsContent(i);
               break;
           }
       }
    }
}

function hideTabsContent(a) {
    for (var i=a; i<tabContent.length; i++) {
        tabContent[i].classList.remove('show');
        tabContent[i].classList.add("hide");
        tab[i].classList.remove('whiteborder');
    }
}

function showTabsContent(b){
    if (tabContent[b].classList.contains('hide')) {
        hideTabsContent(0);
        tab[b].classList.add('whiteborder');
        tabContent[b].classList.remove('hide');
        tabContent[b].classList.add('show');
    }
}















  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-for-2g-hemp"] && !Shopify.designMode) return;
  try {
    
  
  var tab; // заголовок вкладки
var tabContent; // блок содержащий контент вкладки


window.onload=function() {
    tabContent=document.getElementsByClassName('tabContent');
    tab=document.getElementsByClassName('tab');
    hideTabsContent(1);
}

document.getElementById('tabs').onclick= function (event) {
    var target=event.target;
    if (target.className=='tab') {
       for (var i=0; i<tab.length; i++) {
           if (target == tab[i]) {
               showTabsContent(i);
               break;
           }
       }
    }
}

function hideTabsContent(a) {
    for (var i=a; i<tabContent.length; i++) {
        tabContent[i].classList.remove('show');
        tabContent[i].classList.add("hide");
        tab[i].classList.remove('whiteborder');
    }
}

function showTabsContent(b){
    if (tabContent[b].classList.contains('hide')) {
        hideTabsContent(0);
        tab[b].classList.add('whiteborder');
        tabContent[b].classList.remove('hide');
        tabContent[b].classList.add('show');
    }
}















  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-for-pre-rolls-hemp"] && !Shopify.designMode) return;
  try {
    
  
var tab; // заголовок вкладки
var tabContent; // блок содержащий контент вкладки


window.onload=function() {
    tabContent=document.getElementsByClassName('tabContent');
    tab=document.getElementsByClassName('tab');
    hideTabsContent(1);
}

document.getElementById('tabs').onclick= function (event) {
    var target=event.target;
    if (target.className=='tab') {
       for (var i=0; i<tab.length; i++) {
           if (target == tab[i]) {
               showTabsContent(i);
               break;
           }
       }
    }
}

function hideTabsContent(a) {
    for (var i=a; i<tabContent.length; i++) {
        tabContent[i].classList.remove('show');
        tabContent[i].classList.add("hide");
        tab[i].classList.remove('whiteborder');
    }
}

function showTabsContent(b){
    if (tabContent[b].classList.contains('hide')) {
        hideTabsContent(0);
        tab[b].classList.add('whiteborder');
        tabContent[b].classList.remove('hide');
        tabContent[b].classList.add('show');
    }
}

  

  } catch(e) { console.error(e); }
})();
})();
